import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useAdminSession } from "../../app/providers";
import type { AdminBoGateway, AdminBoQuery } from "./gateway";
import type { BusinessOperationPageId } from "./BusinessOperationsPage";

export const businessOperationKeys = {
  all: (sessionEpoch: number) => ["admin", sessionEpoch, "business-operations"] as const,
  list: (sessionEpoch: number, pageId: BusinessOperationPageId, query: AdminBoQuery) => (
    [...businessOperationKeys.all(sessionEpoch), pageId, query] as const
  ),
};

export function useBusinessOperationList(
  pageId: BusinessOperationPageId,
  query: AdminBoQuery,
  gateway: AdminBoGateway,
) {
  const session = useAdminSession();
  return useQuery({
    queryKey: businessOperationKeys.list(session.sessionEpoch, pageId, query),
    queryFn: ({ signal }) => gateway.search(pageId, query, signal),
    placeholderData: keepPreviousData,
    refetchOnMount: "always",
    staleTime: 0,
  });
}
